import { render, staticRenderFns } from "./ChatDock.vue?vue&type=template&id=06447fdb&scoped=true&"
import script from "./ChatDock.vue?vue&type=script&lang=js&"
export * from "./ChatDock.vue?vue&type=script&lang=js&"
import style0 from "./ChatDock.vue?vue&type=style&index=0&id=06447fdb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06447fdb",
  null
  
)

export default component.exports